/** Per room image: run room_image_render POSTs one at a time (API returns 409 if concurrent). */

const queuesByRoomImageId = new Map();

function getQueue(roomImageId) {
  const key = String(roomImageId);
  if (!queuesByRoomImageId.has(key)) {
    queuesByRoomImageId.set(key, { items: [], running: false });
  }
  return queuesByRoomImageId.get(key);
}

async function pump(roomImageId) {
  const queue = getQueue(roomImageId);
  if (queue.running || queue.items.length === 0) return;

  queue.running = true;
  const { run, resolve, reject } = queue.items.shift();

  try {
    const result = await run();
    resolve(result);
  } catch (err) {
    reject(err);
  } finally {
    queue.running = false;
    void pump(roomImageId);
  }
}

/**
 * Queue a room_image_render job. Only one POST runs at a time per room image;
 * up to N jobs may wait in line (enforced by the caller).
 * @param {number} roomImageId
 * @param {() => Promise<any>} run
 * @returns {Promise<any>}
 */
export function enqueueRoomImageRenderWork(roomImageId, run) {
  const queue = getQueue(roomImageId);
  return new Promise((resolve, reject) => {
    queue.items.push({ run, resolve, reject });
    void pump(roomImageId);
  });
}

/** Drop queued (not yet started) work when the active room image changes. */
export function clearRoomImageRenderQueue(roomImageId) {
  if (roomImageId == null) return;
  const key = String(roomImageId);
  const queue = queuesByRoomImageId.get(key);
  if (!queue) return;

  const err = new Error('Render queue cleared');
  for (const item of queue.items) {
    item.reject(err);
  }
  queue.items = [];
}
